import type { GraphInstanceGetter } from '../types';

const FIT_MARGIN = 20;

export function createZoomActions(getGraph: GraphInstanceGetter) {
  return {
    zoomIn(): void {
      getGraph()?.zoomIn();
    },
    zoomOut(): void {
      getGraph()?.zoomOut();
    },
    zoomActual(): void {
      getGraph()?.zoomActual();
    },
    zoomFit(): void {
      getGraph()?.fit(undefined, undefined, FIT_MARGIN);
    },
  };
}
